export const normalizeAgreementPayload = (payload) => {
  const data = payload?.data ?? payload ?? {};

  return {
    agreementId: data?.id ?? null,
    title: data?.title ?? 'User agreement',
    agreementUrl: data?.agreementUrl ?? null,
    version: data?.version ?? null,
    summary: data?.summary ?? '',
    active: Boolean(data?.active ?? data?.isActive ?? false),
  };
};

export const normalizeAgreementState = (payload) => {
  const data = payload?.data ?? payload ?? {};

  return {
    required: Boolean(data?.required ?? false),
    agreementId: data?.agreementId ?? data?.id ?? null,
    title: data?.title ?? 'User agreement',
    agreementUrl: data?.agreementUrl ?? null,
    version: data?.version ?? null,
    summary: data?.summary ?? '',
    acceptedAt: data?.acceptedAt ?? null,
  };
};
